export default __webpack_public_path__ + "static/media/Rob-Pascucci-lo-res.7d069729.jpg";